import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

// form attributes
import { caseDesignAttributes } from '../helpers/form';
import { Typography } from '../../../components/Wrappers/Wrappers';
import TagSelect from './TagSelect';

const TreatmentTypeNote = () => (
    <>
        <Typography weight="bold" style={{ marginBottom: 5 }}>
            Note: Treatment type change
        </Typography>
        <Typography style={{ marginBottom: 35 }}>
            No additional charge if treatment type remains the same. However, an additional charge of $300 will occur if
            treatment type is upgraded from 5-5 to 7-7.
        </Typography>
    </>
);

const EssixRetainerNote = () => (
    <div style={{ marginBottom: 25, padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
        <Typography weight="bold" style={{ marginBottom: 8 }}>
            Notes:
        </Typography>
        <Typography style={{ marginBottom: 8, fontStyle: 'italic' }}>
            • Final set of retainers are <strong>free</strong> at the end of treatment.
        </Typography>
        <Typography style={{ marginBottom: 8, fontStyle: 'italic' }}>
            • When retainers are needed, email us with details at <br />
            orders@smile-academy.com.au
        </Typography>
        <Typography style={{ fontStyle: 'italic' }}>
            • We also offer fixed retainer (straight or hygienic wire) – fees apply.
        </Typography>
    </div>
);

const CaseDesign = ({ newOrder, allowFullArchTreatment, formErrors, onTextFieldChange }) => {
    const renderField = (attr) => {
        // Special handling for mainComplaints using TagSelect
        if (attr.id === 'mainComplaints' && attr.type === 'multiselect') {
            return (
                <TagSelect
                    key={attr.id}
                    id={attr.id}
                    label={attr.label}
                    options={attr.items}
                    value={newOrder[attr.id] || []}
                    onChange={onTextFieldChange}
                    required={attr.required}
                    error={formErrors[attr.id]}
                    helperText={attr.helperText}
                />
            );
        }

        // Default single-select field
        return (
            <FormControl key={attr.id} variant="outlined" onChange={onTextFieldChange} style={{ marginBottom: 35 }}>
                <InputLabel id={`${attr.id}-label`} required={attr.required}>
                    {attr.label}
                </InputLabel>
                <Select
                    labelId={`${attr.id}-label`}
                    id={attr.id}
                    value={newOrder[`${attr.id}`] || ''}
                    name={attr.id}
                    onChange={onTextFieldChange}
                    label={attr.label}
                    error={formErrors[attr.id]}
                >
                    {attr.items.map((item) => (
                        <MenuItem key={item.value || item} value={item.value || item}>
                            {item.displayValue || item}
                        </MenuItem>
                    ))}
                </Select>
                {attr.helperText && <FormHelperText>{attr.helperText}</FormHelperText>}
            </FormControl>
        );
    };

    return (
        <>
            {newOrder.refinement === 'Yes' && <TreatmentTypeNote />}

            {caseDesignAttributes(newOrder, allowFullArchTreatment)
                .filter((attr) => !attr.hidden)
                .map(renderField)}

            <EssixRetainerNote />

            <TextField
                id="instructions"
                label="Summarise Treatment Goal"
                onChange={onTextFieldChange}
                value={newOrder.instructions || ''}
                name="instructions"
                multiline
                minRows="5"
                margin="normal"
                variant="outlined"
                style={{ marginBottom: 35 }}
                required
                error={formErrors.instructions || (newOrder.instructions && newOrder.instructions.length > 1000)}
                helperText={
                    newOrder.instructions && newOrder.instructions.length > 1000
                        ? `Character limit exceeded (${newOrder.instructions.length}/1000)`
                        : formErrors.instructions
                        ? 'This field is required'
                        : 'Please indicate if the patient has crowns, veneers, missing teeth (including their position) or other important information'
                }
            />
        </>
    );
};

export default CaseDesign;
